import { SoftwareStatus } from '@customer/store/apis/assetsApi';
import { setSoftwareStatus } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import SingleSelectFilter from './SingleSelectFilter';
import { FilterInputProps } from '@customer/filters/types';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';

const useSoftwareStatusOptions = (): DropdownItemProps<SoftwareStatus>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.keys(SoftwareStatus).map((key: string) => {
      const value = SoftwareStatus[key as keyof typeof SoftwareStatus];
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`filters.SoftwareStatus.${key}`),
      };
    });
  }, [t]);
};

export const SoftwareStatusFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();

  return (
    <SingleSelectFilter<SoftwareStatus>
      filterName="softwareStatus"
      label={label ?? t('SoftwareStatus')}
      elementRef={elementRef}
      action={setSoftwareStatus}
      useItemsHook={useSoftwareStatusOptions}
    />
  );
};

export default SoftwareStatusFilter;
